// =============================================================
// INDOMINA — Custom Scroll Animations
// Vanilla JS + Intersection Observer, zero dipendenze
// =============================================================

(function () {
  'use strict';

  // Rispetta prefers-reduced-motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // --- 1. Reveal on scroll (singoli elementi) ---
  const revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  document.querySelectorAll('[data-indomina-reveal]').forEach(function (el) {
    revealObserver.observe(el);
  });

  // --- 2. Stagger reveal (griglie card) ---
  const staggerObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var cards = entry.target.querySelectorAll('.card');
          cards.forEach(function (card, index) {
            card.style.transitionDelay = (index * 150) + 'ms';
          });
          entry.target.classList.add('is-visible');
          staggerObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08 }
  );

  document.querySelectorAll('[data-indomina-stagger]').forEach(function (el) {
    staggerObserver.observe(el);
  });

  // --- 3. Parallax leggero sull'image banner ---
  var parallaxEls = document.querySelectorAll('.indomina-parallax .banner__media');
  if (parallaxEls.length === 0) return;

  var ticking = false;

  function updateParallax() {
    parallaxEls.forEach(function (el) {
      var section = el.closest('.indomina-parallax');
      if (!section) return;
      var rect = section.getBoundingClientRect();
      var viewH = window.innerHeight;
      // Solo se la sezione è visibile
      if (rect.bottom < 0 || rect.top > viewH) return;
      var progress = (viewH - rect.top) / (viewH + rect.height);
      var shift = (progress - 0.5) * 80; // max ±40px
      el.style.transform = 'translateY(' + shift + 'px)';
    });
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }, { passive: true });

  // Run once on load
  updateParallax();
})();
